import { render, staticRenderFns } from "./setup_contact.vue?vue&type=template&id=7d64142d"
import script from "./setup_contact.vue?vue&type=script&lang=js"
export * from "./setup_contact.vue?vue&type=script&lang=js"
import style0 from "./setup_contact.vue?vue&type=style&index=0&id=7d64142d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports